import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

export const RootStyled = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '10px 16px',
  maxWidth: '500px',
  border: '0.6px solid #707070',
  borderRadius: '4px',
  marginTop: '12px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));

export const PreviewContainer = styled(Box)({
  mt: 2,
  maxWidth: '100%',
  maxHeight: '500px',
  overflow: 'auto',
  border: '1px solid #e0e0e0',
  borderRadius: '4px',
  p: 1,
});

export const StyledModal = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '90vw',
  maxHeight: '90vh',
  backgroundColor: '#FFFFFF',
  boxShadow: 24,
  padding: '32px',
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const StyledModalHeader = styled(Box)({
  alignSelf: 'flex-end',
  marginBottom: '8px',
});

export const StyledImageContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  position: 'relative',
});

export const StyledModalImage = styled('img')({
  maxWidth: '100%',
  maxHeight: 'calc(90vh - 100px)',
  objectFit: 'contain',
});
